import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { isAppOnline } from '../../../../modules/app/App/selectors';

import styles from './styles';
import messages from './messages';

export class ChatAppOfflineWarning extends React.PureComponent {
  render() {
    const { online } = this.props;

    if (online) return null;

    return (
      <div style={styles.container}>
        <div style={styles.alertIcon} />
        <span style={styles.text}>
          <FormattedMessage {...messages.warningText} />
        </span>
      </div>
    );
  }
}

ChatAppOfflineWarning.propTypes = {
  online: React.PropTypes.bool,
};

ChatAppOfflineWarning.defaultProps = {
  online: true,
};

const mapStateToProps = state => {
  return {
    online: isAppOnline(state),
  };
};

const connectedComponent = connect(mapStateToProps)(ChatAppOfflineWarning);

export default connectedComponent;
